
import Service from "@/services/Service";
import http from "./Http";

export default class ExternalUserService extends Service{
  getExternalUser (id) {
    const url = 'usuario/'+id+'/prime'
    const config = {
      headers: this.getHeaders()
    };
    return http.get(url, config).then(response =>{
      return response
    })
  }
}